import type {RootState} from "../store";

const selectAnswered = (state: RootState): string[] =>
	state.tutorQuestions.answered;

export default selectAnswered;
